import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBellSlash } from '@fortawesome/free-solid-svg-icons';
import usePush from '../hooks/usePush';
const PushSetup = ({ unreadCount = 0, onOpenNotifications }) => {
    const { supported, enabled, checking, enablePush } = usePush();
    if (!supported || checking)
        return null;
    const handleClick = () => {
        if (enabled) {
            onOpenNotifications?.();
        }
        else {
            void enablePush();
        }
    };
    return (React.createElement("div", { className: "push-setup" },
        React.createElement("button", { type: "button", role: "menuitem", className: "profile-settings-action", onClick: handleClick, "aria-pressed": enabled, "aria-label": enabled ? 'View notifications' : 'Enable notifications', title: enabled ? 'View notifications' : 'Enable notifications', style: { color: enabled ? 'var(--success)' : 'var(--gray-500)', display: 'inline-flex' } },
            React.createElement(FontAwesomeIcon, { icon: enabled ? faBell : faBellSlash }),
            React.createElement("span", { className: "push-status", style: { fontSize: '0.9rem', color: enabled ? 'var(--success)' : 'var(--gray-600)' } }, enabled
                ? (unreadCount > 0 ? `${unreadCount} unread` : 'Enabled')
                : 'Disabled'))));
};
export default PushSetup;
